// Template Generated by DataExtraction.py at 1716507313

import TransferEnglish1 from "../../Forms/Transfer/Transfer_English1.png";
import TransferEnglish1Labels from "../../Labels/Transfer/Transfer_English1.json";
import TransferFrench1 from "../../Forms/Transfer/Transfer_French1.png";
import TransferFrench1Labels from "../../Labels/Transfer/Transfer_French1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, isFemale, isMale, getSubscriber1Address, drawTextScaled as drawTextAtPos
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import { t } from "i18next";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TransferFrench1Labels : TransferEnglish1Labels;
    const formImage = isFrench ? TransferFrench1 : TransferEnglish1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    function drawLongText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const beneficiary = data.beneficiary;
    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const transfer = data.transfer;
    const common = data.common;

    const dateFormat = "YYYY-MM-DD";


    let s1Sin = `${subscriber.sin}`;
    console.log(s1Sin);
    let s2Sin = `${jointSubscriber.sin}`;

    // split sins every 3 characters and if sin is an empty string, set it to empty string
    s1Sin = s1Sin.match(/.{1,3}/g) || [""];
    s2Sin = s2Sin.match(/.{1,3}/g) || [""];

    // add spaces between each sin
    s1Sin = s1Sin.join(" ");
    s2Sin = s2Sin.join(" ");

    // drawTextAtPos(doc, 26, t("Children's Education Funds Inc."), 433 / 3.38, 558 / 3.38, 150 / 3.38);
    // drawTextAtPos(doc, 26, t("3221 North Service Road\nBurlington, ON L7N 3G2"), 433 / 3.38, 571 / 3.38, 150 / 3.38);
    // drawTextAtPos(doc, 26, t("Cheque Payable to:\nChildren's Education Trust"), 432 / 3.38, 597 / 3.38, 150 / 3.38);

    drawText(t("Children's Education Funds Inc."), "rPromotorName")
    drawText(t("3221 North Service Road\nBurlington"), "rPromotorAddress")
    drawText(t("Cheque Payable to:\nChildren's Education Trust"), "rChequeLocation")

    // Drawing the form
    // TODO implement fields
    //drawText(beneficiary.relationshipToSubscriber, "bRelationship");
    drawLongText(transfer.promoterAddress, "promoterAddress");
    drawText(transfer.promoterContractNumber, "promoterContractNumber");
    drawText(transfer.promoterName, "promoterName");
    fillCheckbox(transfer.relinquishIsBeneficiary, "relinquishIsBeneficiary");
    // fillCheckbox(relinquishIsBeneficiary2, "relinquishIsBeneficiary2"); // Unused in ipad
    fillCheckbox(!transfer.relinquishIsBeneficiary, "relinquishIsNotBeneficiary");
    drawText(subscriber.firstName, "s1FirstName");
    drawText(subscriber.lastName, "s1LastName");
    drawText(s1Sin, "s1Sin");
    if (common.subscriber2Include) {
        drawText(jointSubscriber.firstName, "s2FirstName");
        drawText(jointSubscriber.lastName, "s2LastName");
        drawText(s2Sin, "s2Sin");
    }

    if (!transfer.relinquishIsBeneficiary) {
        fillCheckbox(true, "individualRESP");

        fillCheckbox(isMale(transfer.relinquishGender), "relinquishMale");
        fillCheckbox(isFemale(transfer.relinquishGender), "relinquishFemale");

        drawText(transfer.relinquishFirstName, "relinquishFirstName");
        drawText(transfer.relinquishLastName, "relinquishLastName");
        drawText(transfer.relinquishSin, "relinquishSin")
        drawText(moment(transfer.relinquishBirthdate).format(dateFormat), "relinquishDob");

        fillCheckbox(transfer.relinquishMultipleBeneficiary, "relinquishMultipleBeneficiary");
    }

    fillCheckbox(transfer.transferBalance, "transferBalance");
    fillCheckbox(transfer.transferBalance, "transferBalance2");
    fillCheckbox(transfer.transferBalance, "transferBalance3");

    if (!transfer.transferBalance) {
        fillCheckbox(true, "transferPartial");
        fillCheckbox(true, "transferPartial2");
        fillCheckbox(true, "transferPartial3");
        fillCheckbox(true, "transferPartial4");

        if (transfer.transferPercent) {
            drawText(transfer.transferAmount, "transferAmountDuplicate");
            drawText(transfer.transferBc, "transferBcDuplicate");
            drawText(transfer.transferClb, "transferClbDuplicate");
        } else {
            drawText(transfer.transferAmount, "transferAmount");
            drawText(transfer.transferClb, "transferClb");
            drawText(transfer.transferBc, "transferBc");
        }

        drawText(transfer.transferCode1, "transferCode1");
        drawText(transfer.transferCode2, "transferCode2");
        drawText(transfer.transferCode3, "transferCode3");

        drawText(transfer.transferAmount1 == 0 ? "" : transfer.transferAmount1, "transferAmount1");
        drawText(transfer.transferAmount2 == 0 ? "" : transfer.transferAmount2, "transferAmount2");
        drawText(transfer.transferAmount3 == 0 ? "" : transfer.transferAmount3, "transferAmount3");
    }


    drawText(getSubscriber1Address(subscriber), "sAddress");
    drawText(subscriber.city, "sCity");
    drawText(subscriber.postalCode, "sPostalCode");
    drawText(subscriber.province, "sProvince");
    // drawText(subscriber.homePhone, "sTelephone"); // is not used in ipad


}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TransferFrench1Labels : TransferEnglish1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
